export default {
    activateuser: {
        headerLabel: 'Benutzer-einsteigen',
        accountActivation: 'Konto Aktivierung',
        step1: {
            header: 'Willkommen auf unserer Plattform!',
            subHeader: 'Wählen Sie aus, wie Sie sich mit Ihrem Konto verbinden möchten',
            description:
                'Für einen einfacheren Log-in Prozess empfehlen wir Ihnen, Ihr Konto mit mindestens einem der folgenden Dienste zu verbinden.',
            OR: 'oder',
            emailAndPassword: 'Verwenden Sie Ihre eigene E-Mail',
        },
        step2: {
            header: 'E-Mail und Passwort verwenden',
            description:
                'Dies ist die Haupt-E-Mail, die Ihrem Konto zugeordnet wird. Wir empfehlen Ihnen, eine andere E-Mail-Adresse als Ihre Universitätsadresse zu verwenden, um auch nach dem Studium Zugriff auf Ihre Daten zu haben. Sie können ganz einfach in Ihren Kontoeinstellungen steuern, welche E-Mails Sie von uns erhalten.',
            invalidEmail: 'Die angegebene E-Mail ist ungültig.',
            passwordsNotMatch: 'Die Passwörter müssen übereinstimmen',
            passwordDescription01:
                'Um Ihr Konto zu schützen, müssen Sie ein neues Passwort festlegen. Bitte erstellen Sie ein Passwort mit folgendem:',
            passwordDescription02: 'Mindestens 8 Zeichen',
            passwordDescription03: 'Mindestens ein Kleinbuchstabe (a-z)',
            passwordDescription04: 'Mindestens ein Großbuchstabe (A-Z)',
            passwordDescription05: 'Mindestens eine Zahl oder ein Sonderzeichen (0-9, !#$ usw.)',
            passwordDescription06: 'Mindestens 6 einzigartige Charaktere',
            repeatPassword: 'Passwort wiederholen',
        },
        step3: {
            header: 'Benutzer aktivieren',
            loadingHints: {
                0: 'Benutzerdaten laden',
                1: 'Alles fertig machen',
                2: 'Neue Möglichkeiten um die Ecke',
                3: 'Fast fertig!',
            },
            successHeader: 'Ihr Konto ist jetzt einsatzbereit!',
            successSubheader: 'Sie können jetzt auf exklusive Funktionen zugreifen!',
            errorHeader: 'Konto konnte nicht aktiviert werden',
            ifWrongContact:
                'Wenn Sie der Meinung sind, dass dies falsch ist, wenden Sie sich bitte an den Support',
            contactForHelp: 'Kontaktieren Sie uns für Hilfe',
            goBack: 'Geh zurück',
        },
    },
    assessments: {
        general: {
            checkMyProgress: 'Überprüfe meinen Fortschritt',
            getStarted: 'Loslegen!',
            getToKnowYourself: 'Lernen Sie sich selbst kennen',
            getToKnowYourselfBold: 'Lernen Sie <strong>sich selbst</strong> kennen',
            getToKnowYourFuture: 'Ihre Zukunft kennen',
            getToKnowYourFutureBold: 'Lernen Sie Ihre <strong>Zukunft</strong> kennen',
            openAssessments: 'Einschätzungen ӧffnen',
            openAssessment: 'Bewertung öffnen',
            unlock: 'Schalten Sie die Tests frei',
            testYourself: 'Testen Sie sich',
            takeTheFreeTests: 'Machen Sie die kostenlosen Tests',
            youOwnThisProduct: 'Sie besitzen dieses Produkt',
            startTest: 'Test anfangen',
            startTests: 'Tests anfangen',
            continue: 'Weitermachen',
            showReport: 'Zeige Bericht',
            showYourReports: 'Zeigen Sie Ihre Berichte',
            showYourReport: 'Zeigen Sie Ihren Bericht',
            continueFreeTests: 'Setzen Sie die kostenlosen Tests fort',
            continueTheTest: 'Setzen Sie den Test fort',
            estimatedTime: '~ {min} min',
        },
        landing: {
            section1: {
                title: 'Testen Sie sich selbst',
                description01: 'Willkommen im Assessment Center - hier beginnt Ihre Karriere.',
                description02:
                    'Hier können Sie <strong>Aon Einschätzungen</strong> ablegen, Tests, die von Persӧnliche Vermittlern weltweit verwendet werden, um Ihre Eignung und Bereitschaft für eine zukünftige Karriere zu überprüfen.',
                freemium: {
                    description:
                        'Machen Sie diese Tests, um Ihre Stärken zu messen und effiziente Berichte über Ihre Fähigkeiten zu erhalten.',
                    price: 'Frei',
                    numTests: '3 Teste',
                    timeEstimated: 'ca. 27 Minuten',
                },
                premium: {
                    description:
                        'Dies ist der <strong>echte Deal</strong>. Machen Sie diesen 3-in-1-Test, um herauszufinden, welche Karrierewege Sie einschlagen sollten, und erhalten Sie einen vollständigen Kandidatenbericht.',
                    numTests: '3-in-1 test',
                    timeEstimated: 'ca. 60 Minuten',
                    sampleReport: '↓Beispielbericht herunterladen',
                    candidateReport: 'Kandidatenbericht',
                    candidateReportDescription:
                        'Sobald Sie diese Tests abgeschlossen haben, erhalten Sie einen vollständigen Kandidatenbericht mit einem umfassenden Überblick über Ihre Ergebnisse, einschließlich Tipps zur Verbesserung Ihrer persönlichen Fähigkeiten, auf welche Fähigkeiten Sie achten sollten, die besten Möglichkeiten für den Anfang, was Ihr nächster Schritt sein sollte, und mehr.',
                },
            },
            section2: {
                title: 'Wie helfen Ihnen diese Tests bei der Einstellung?',
                t1: 'Sie kennen Ihre <strong>Fähigkeiten</strong>',
                t2: 'Sie werden Ihr <strong>Potenzial</strong> erkennen',
                t3: 'Sie haben einen klaren <strong>Karriereweg</strong>',
                t4: 'Sie stärken Ihr <strong>Selbstvertrauen</strong>',
            },
            section3: {
                title: 'Erfahren Sie mehr über Ihre persönlichen Stärken und Karrieremöglichkeiten, um Ihre Entwicklung und Ihren beruflichen Aufstieg voranzutreiben.',
            },
            section4: {
                title: 'Seien Sie Ihren Mitbewerbern noch heute voraus',
                description:
                    'Durch das Absolvieren von Einschätzungen die von Arbeitnehmer weltweit bei Unternehmen wie Deloitte, Siemens, Burger King, Vodafone oder P&G verwendet werden.',
            },
            section5: {
                title: 'Häufig gestellte Fragen',
                thisPage: 'diese Seite',
                question01: {
                    q: 'Was sind Aon-Einschätzungen',
                    a: 'Begabung Bewertungstest von Aon sind weltweit anerkannte Tests, die Unternehmen auf der ganzen Welt helfen, die besten Kandidaten für eine Stelle zu identifizieren. Mit Hilfe von Begabung Bewertung können Arbeitnehmer über Lebensläufe, Schulnoten, Hochschulzeugnisse und Universitätsdiplome hinausschauen, um herauszufinden, ob ein Kandidat gut passt.\n <br><br>\n Diese Lösungen sind normalerweise <strong>für Nur für Personalvermittler</strong> – hier haben Sie die <strong>exklusive</strong> Gelegenheit, vor Ihrem Vorstellungsgespräch zu üben und Ihre Ergebnisse zu erzielen. Die meisten Kandidaten bekommen diese Chance nicht, also nutze sie!ä',
                },
                question02: {
                    q: 'Muss ich für diese Einschätzungen bezahlen?',
                    a: 'Sie können 4 dieser Tests kostenlos absolvieren – <i>Arbeitsbezogenes Verhalten</i>, <i>Numerisches Denken</i>, <i>Deduktives logisches Denken</i> und <i>Induktives logisches Denken</i>. Diese Tests messen Ihre Fähigkeiten und Begabungen und sind eine großartige Möglichkeit, Ihre Stärken und Schwächen herauszufinden.\n\n <br><br>Wenn Sie jedoch einen vollständigen Überblick über Ihre Neigungen haben möchten, erhalten Sie professionelle Einblicke zu Ihrem besten Karriereweg und machen Sie einen großen Schritt in Richtung des Zukunftserfolgs, können Sie auch auf den 3-in-1-Test zugreifen und einen umfassenden Kandidatenbericht für 79 € erhalten. <br><br>Für den erweiterten Zugang einfach <a href={premiumLink}>hier klicken</a> und mit Karte bezahlen – wir verwenden eine sichere Zahlungsmethode.\n',
                },
                question03: { q: 'Warum sollte ich diese Tests machen?' },
                question04: {
                    q: 'Wie kann ich mich auf diese Tests vorbereiten?',
                    a: 'Auf <a href={link} target="_blank">dieser Seite</a> erfahren Sie alles über die technischen Voraussetzungen und wie Sie sich auf die Prüfungen vorbereiten. Dort finden Sie auch Materialien, die Ihnen helfen, es zu schaffen',
                },
                question05: {
                    q: 'Wo finde ich diese Einschätzungen noch?',
                    a: 'Normalerweise werden Sie möglicherweise von Ihrem Arbeitnehmer aufgefordert, diese Tests durchzuführen – ansonsten werden Sie diese nirgendwo anders für Sie finden. Dies ist eine exklusive Gelegenheit für Sie, zu üben, mehr über sich selbst und Ihre berufliche Zukunft zu erfahren.',
                },
                question06: {
                    q: 'Wie oft kann ich die Tests machen?',
                    a: 'Für jeden Test kӧnnen Sie nur einmal ablegen. Keine Wiederholungen! Stellen Sie sicher, dass Sie bequeme Bedingungen haben, um diese Gelegenheit zu nutzen. Sie können sich mit dem Test vertraut machen, indem Sie sich Anleitungsvideos ansehen und eine Übung durchführen, bevor Sie den Test ablegen.',
                },
                question07: {
                    q: 'In welcher Sprache sind diese Tests?',
                    a: '\n Die Standardsprache für diese Tests ist Englisch, jedoch stehen für jeden von ihnen verschiedene Sprachen zur Auswahl. Sie können überprüfen, welche Sprachen verfügbar sind und die für Sie am besten geeignete auswählen, bevor Sie den Test ablegen. \n',
                },
                question08: {
                    q: 'Gibt es ein Ablaufdatum für die erweiterten Tests, sobald ich sie bezahle?',
                    a: 'Nein! Nachdem Ihre Zahlung akzeptiert wurde, können Sie an den erweiterten Tests teilnehmen, wann immer Sie möchten. Nehmen Sie sich Zeit für die Vorbereitung und beginnen Sie mit den Einschätzungen wann immer es Ihnen am besten passt',
                },
            },
        },
        center: {
            banner: {
                title: 'Überprüfe deinen Fortschritt',
                subtitle: 'Hier ist ein Überblick über Ihre Fortschritte bei der Karrierebewertung',
                moreInfo: 'Mehr Informationen',
                yourProgress: 'Dein Fortschritt',
                quote: 'Das Setzen von Zielen ist der erste Schritt, um das Unsichtbare in das Sichtbare zu verwandeln.',
            },
            list: {
                timeEstimated: 'ca. {Minuten} Min',
                freemium: {
                    intro: '\n Dies ist der erste Schritt auf Ihrem persönlichen Entwicklungsweg! <br />\n Legen Sie diese Tests ab, um Ihre Stärken zu messen und effiziente Berichte über Ihre\n Fähigkeiten zu erhalten.\n',
                },
                premium: {
                    intro: '\n Das ist das einzig Wahre.<br />\n Machen Sie diese Tests, um herauszufinden, welche Karrierewege Sie einschlagen sollten, und erhalten Sie einen umfassenden\n <strong>Kandidatenbericht</strong>.\n',
                    description:
                        '\n Ihr <strong>Kandidatenbericht</strong> gibt Ihnen einen umfassenden\n Überblick über Ihre Ergebnisse, einschließlich <strong>Tipps</strong> zur Verbesserung Ihrer\n persönlichen Fähigkeiten, die <strong>Fähigkeiten</strong> Sie sollten auf die\n besten <strong>Chancen</strong> achten, was Ihr\n <strong>nächster Schritt</strong> sein sollte und vieles mehr.\n',
                },
            },
            instruments: {
                344: {
                    name: 'Deduktiogisches Denken',
                    description:
                        'Erkennen Sie, wie gut Sie Wissen anwenden und Regeln anwenden – dieser Test misst Ihre analytischen und problemlösenden Fähigkeiten.',
                },
                383: {
                    name: 'Induktives logisches Denken',
                    description:
                        'Wie gut können Sie Regeln und Zusammenhänge erkennen? Prüfen Sie mit diesem Test, der Ihre analytischen und problemlösenden Fähigkeiten misst.',
                },
                390: {
                    name: 'Arbeitsbezogenes Verhalten',
                    description:
                        'Welche Persönlichkeitsmerkmale der Mitarbeiter haben Sie? Finden Sie es heraus, indem Sie diesen Test ablegen, der Ihre arbeitsbezogenen Persönlichkeitsmerkmale identifiziert.',
                },
                721: {
                    name: 'Numerisches Denken',
                    description:
                        'Wie gut sind Sie im Umgang mit Zahlen? Dieser Test misst Ihr Verständnis von numerischen Informationen und die Erreichung von logischen Schlussfolgerungen.',
                },
                5392: {
                    name: 'Arbeitsspeicher',
                    description:
                        'Wie gut können Sie konzentriert bleiben? Dieser Test misst die Fähigkeit, Informationen in ablenkenden Umgebungen zu verarbeiten und sich daran zu erinnern.',
                },
                82013: {
                    name: 'Flextest',
                    description:
                        'Was sind deine Interessen? Anhand dieses Fragebogens können Sie ermitteln, welchen Karriereweg Sie einschlagen möchten.',
                },
            },
        },
        dialog: {
            header: 'Fangen Sie mit Ihren Aon-Einschätzungen an',
            consent:
                'Ich begreife, dass Aon für meine Daten im Zusammenhang mit dieser Bewertung verantwortlich ist und stimme deren Geschäftsbedingungen zu.\n Ich stimme auch zu, dass Highered meinen Namen an Aon übertragen kann, um meinen Bericht zu erstellen.',
            startTest: 'Test anfangen',
            consentErrorTitle: 'Einwilligungsfehler',
            consentErrorMessage:
                'Beim Senden Ihrer Einwilligung ist ein Fehler aufgetreten. Haben Sie Ihre E-Mail bestätigt?',
        },
    },
    "<br><br>\\n           Premier - vous arrivez préparé avec une partie du processus de recrutement déjà effectuée, ce qui vous fera instantanément prendre de l'avance sur les autres candidats":
        {
            '\\n            <br><br>\\n Deuxième - vous abordez votre recrutement avec un esprit clair':
                {
                    " Vous connaissez vos points forts et ce que l'avenir vous réserve - motivation instantanée et véritable regain de confiance garantis! Les recruteurs pourront le dire":
                        {
                            '"': '\n                Recrutadores de todo o mundo usam os testes de avaliação da AON em seu processo de seleção de candidatos. Ao concluí-los previamente e apresentá-los com relatórios prontos, você terá a grande oportunidade de realmente surpreender os recrutadores. Como? \n                <br><br>\n                Primeiro – você vem preparado com parte do processo de recrutamento já feito, o que o fará saltar imediatamente à frente de outros candidatos.\n                <br><br>\n                Segundo – você se aproxima do seu recrutamento com a mente clara. Você conhece seus pontos fortes e o que o futuro reserva para você – motivação instantânea e um aumento de confiança garantido! Os recrutadores saberão disso! ',
                        },
                },
        },
    calendar: {
        header: 'Kalender',
        myCalendar: 'Mein Kalender',
        noCalendar: 'Ihr Karriereservice hat die Kalenderfunktion noch nicht aktiviert.',
        goBackBtn: 'Geh zurück',
        calendarNotReady: 'Die Funktion "Mein Kalender" ist noch nicht bereit. Demnächst',
        noUpcomingAppointments: 'Sie haben keine bevorstehenden Termine.',
        appointmentMissing: 'Termin nicht aktiv',
        appointmentNotActive:
            'Leider haben Sie versucht, einen Termin anzuzeigen, der nicht vorhanden oder nicht aktiv ist.',
        appointmentNotHavingAvailability:
            'Dieser Termin ist im Moment leider nicht verfügbar. Schauen Sie später noch einmal vorbei.',
        appointmentMissingRules: 'Termin ist nicht verfügbar',
        needToCompleteProfile: 'vervollständige dein Profil',
        noUpcomingAppointmentsPleaseBook:
            'Buchen Sie einen Termin, um Ihren Kalender zu entsperren.',
        bookAppointment: 'Einen Termin verabreden',
        bookAnotherAppointment: 'Vereinbare einen Termin',
        attendedAppointments: 'Termine, an denen Sie teilgenommen haben',
        aboutAppointments: {
            header: 'Über Termine',
            button: 'Über',
            block1: { header: 'Was ist ein Termin?' },
        },
        bookAnAppointment: 'Vereinbare einen Termin',
        backToCalendarBtn: 'Zurück zum Kalender',
        backToBookingBtn: 'Zurück zur Terminliste',
        firstAvailable: 'Zuerst verfügbar',
        loadingAppointment: 'Wird geladen …',
        bookModal: {
            title: 'Buchung bestätigen',
            with: 'Mit',
            confirm: 'Bestätigen Sie',
            continue: 'Weitermachen',
            cancel: 'Schließen',
            first: {
                title: 'Das ist Ihre erster Termin',
                description:
                    'Um sicherzustellen, dass Sie die Veranstaltungseinladung erhalten, bestätigen Sie bitte, dass Sie über dieses E-Mail-Konto Zugriff auf einen persönlichen Kalender haben',
                ok: 'OK',
                wrongEmail: 'Falsche E-mail?',
            },
            changeEmail: {
                title: 'Wählen Sie Ihre Kalender-E-Mail aus',
                inputPlaceholder: 'E-Mail eingeben ...',
                ok: 'OK',
                back: 'Verwende den Standard',
            },
            unknownErrorHeader: 'Beim Buchen ist ein Fehler aufgetreten',
            unknownErrorBody:
                'Bitte versuchen Sie, ein anderes Mal zu buchen, und wenn dies nicht funktioniert, wenden Sie sich an den Support.',
            confirmationHeader: 'Ihr Termin ist gebucht!',
            bookedTheFollowing: 'Einzelheiten:',
            emailWillBeSent: 'Eine E-Mail wird gesendet an',
            withConfirmation: 'die Sie bittet, Ihre Teilnahme zu bestätigen.',
        },
        dateDetailsModal: { title: 'Termine am' },
        completedYourProfile:
            'Sie müssen Ihr Profil vervollständigen, um Zugang zum Kalendersystem zu erhalten',
        toMyProfile: 'Mein Profil bearbeiten',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: '{name} möchte dein Profil sehen',
            content: 'Möchten Sie Ihr Profil mit dieser Person teilen?',
            share: 'Profil teilen',
            reject: 'Nein',
        },
    },
    companyDetail: {
        locations: {
            header: 'Standorte',
            viewAll: 'Alles sehen',
            noLocations: 'Keine Standorte',
            allLocations: 'Alle Orte',
        },
        jobModule: {
            header: 'Spitzenposition',
            viewAllJobs: 'Alle Jobs von {companyName} ansehen',
            noPositions: '{companyName} hat derzeit keine offenen Stellen bei Highered.',
            defaultLabel: 'offene Positionen',
        },
        videos: {
            header: 'Videos',
            noVideos: 'keine Videos',
            noMoreVideos: 'Keine Videos mehr',
            moreVideosFrom: 'Mehr Videos von {companyName}',
        },
        articles: {
            header: 'Artikel',
            noArticles: 'Keine Artikel',
            noMoreArticles: 'Keine Artikel mehr',
            moreArticlesFrom: 'Mehr Artikel von {companyName}',
        },
    },
    components: {
        builders: {
            searchable: { create: 'erschaffen' },
            yearMonthPicker: { defaultSelect: 'Wähle einen Monat' },
            localeDropdown: {
                languages: { en: 'Englisch', cn: 'Chinesisch', fr: 'Französisch' },
            },
        },
        miscellaneous: {
            verifyModule: {
                title: 'Bestätigen Sie Ihre Schul-E-Mail',
                description:
                    'Es ist ein schneller Prozess und bietet Ihnen Zugriff auf\n exklusive Funktionen wie einzigartige Stellenausschreibungen, Fertigkeitstests und Karriereressourcen.',
                verificationPending: 'Überprüfung ausstehend',
                weHaveSentAnEmail:
                    'Wir haben eine E-Mail an\n <strong>{studentEmail}</strong> gesendet, damit\n Sie sich verifizieren können. Achten Sie darauf,\n Ihren Spam-Ordner zu überprüfen, da viele Schulen sehr streng mit eingehenden E-Mails umgehen.',
                verifyMe: 'verifiziere mich',
                resendVerifyEmail: 'Bestätigungsmail erneut senden',
                cancelVerification: 'Bestätigung abbrechen',
                emailSent: 'E-Mail gesendet',
                emailSentMessage:
                    'E-Mail wurde erfolgreich gesendet. Wenn Sie es nicht erhalten, kontaktieren Sie uns unter support@highered.global.',
                resendErrorTitle: 'Fehler beim erneuten Senden der E-Mail',
                resendErrorMessage:
                    'Bestätigungs-E-Mail konnte nicht erneut gesendet werden. Bitte kontaktieren Sie uns unter support@highered.global.',
                verificationCancelledTitle: 'Bestätigung abgebrochen',
                verificationCancelledMessage: 'Die Verifizierung wurde erfolgreich abgebrochen.',
                cancelErrorTitle: 'Fehler beim Abbrechen',
                cancelErrorMessage:
                    'Die Verifizierung konnte nicht abgebrochen werden. Bitte kontaktieren Sie uns unter support@highered.global.',
            },
            verifyModuleDialog: {
                title: 'Bestätigen Sie Ihre Schul-E-Mail',
                university: 'Akademische Einrichtung',
                studentEmail: 'Ihre akademische E-Mail-Adresse',
                studentEmailPlaceholder: 'Akademische E-Mail',
                message: 'Nachricht',
                verify: 'Verifizieren',
                sendRequest: 'Anfrage senden',
                verificationInProcess: 'Überprüfung in Bearbeitung',
                emailHasBeenSentTo:
                    'Eine E-Mail wurde an <strong>{email}</strong> gesendet. Befolgen Sie die dortigen Anweisungen, um Ihre Verbindung zu <strong>{schoolName}</strong> zu bestätigen.',
                verificationRequestSentNonAcademic:
                    'Die Karrieredienste von <strong>{schoolName}</strong> müssen Ihre Verbindung bestätigen. Sie werden per E-Mail benachrichtigt, wenn dies geschieht.',
                ifNoEmailRecieved:
                    'Wenn Sie die Bestätigungsmail nicht erhalten haben, kontaktieren Sie uns bitte.',
                contactHelp: 'Kontaktieren Sie uns für Hilfe',
                doNotHaveAcademicEmail: 'Ich habe keine akademische E-Mail-Adresse',
                doubleCheckEmail:
                    'Bitte überprüfen Sie, ob diese E-Mail-Adresse korrekt ist und Sie Zugriff darauf haben.',
                haveAcademicEmail: 'Ich habe eine akademische E-Mail-Adresse',
                noAcademicEmailInfo:
                    'Wenn Sie keine akademische E-Mail-Adresse verwenden, muss Ihr Antrag manuell von den Career Services genehmigt werden. Sie müssen daher eine kurze Nachricht übermitteln, um sich zu identifizieren.',
                alreadyVerifiedInfo: 'Sie sind bereits an dieser Schule verifiziert.',
            },
        },
        navigation: {
            navigation: {
                myPage: 'Meine Seite',
                jobs: 'Arbeitsplätze',
                companies: 'Firmen',
                masterclasses: 'Meister Klasse',
                assessments: 'Einschätzungen',
                countryGuides: 'Länderführer',
                goToHaigui: 'Jobs in China',
                signIn: 'Einloggen/ Anmelden',
                vfairs: 'virtuelle Ereignisse',
                events: 'Ereignis',
                newFeature: 'neue Funktion',
            },
            profileNavigation: { signOut: 'Ausloggen' },
            sidebar: {
                myPage: 'meine Seite',
                myProfile: 'mein Profil',
                findJobs: 'Arbeitsplätze finden',
                findCompanies: 'Unternehmen finden',
                masterclasses: 'Meisterklasse',
                assessments: 'Einschätzungen',
                countryGuides: 'Länderführer',
                goToHaigui: 'Arbeitsstelle in china',
                virtualFairs: 'Virtuelle Ereignisse',
                signIn: '"Einloggen Anmelden',
                logOut: 'Ausloggen',
            },
            backToCalendar: 'zurück zum Kalender',
            allBooths: 'alle Stände',
            home: 'Heim',
        },
        smart: {
            companyModule: {
                followJob: 'Zu den Favoriten hinzufügen',
                followCompany: 'Gesellschaft folgen',
                unFollowJob: 'aus Favoriten entfernen',
                unFollowCompany: 'Unternehmen nicht mehr folgen',
                favoritedTitle: 'In den Favoriten gespeichert',
                favoritedMessage:
                    'Diese Position wurde in Ihren Favoriten gespeichert. Finden Sie Ihre Lieblingspositionen auf meiner Seite.',
                unfavoritedTitle: 'Aus Favoriten entfernt',
                unfavoritedMessage: 'Diese Position wurde aus Ihren Favoriten entfernt.',
                favoriteErrorTitle: 'Etwas ist schief gelaufen',
                favoriteErrorMessage: 'Konnte diese Position nicht favorisieren',
                showAllCompanies: 'Alle Unternehmen anzeigen',
                showOnlyCompaniesLiveOnChat: 'Nur Unternehmen live im Chat anzeigen',
            },
            profileModule: {
                profileCompletion: 'Profilvervollständigung',
                profileCompletionEncouragement:
                    'Präsentieren Sie sich Arbeitgebern, indem Sie die letzten {prozentsatz übrig} Ihres Profils ausfüllen',
                gotoProfilePage: 'Profil aktualisieren',
                profileCompleted: 'Profil abgeschlossen',
                profileCompletedWhatsNext:
                    'Wussten Sie, dass die meisten Arbeitgeber Online Bewertung in ihren Rekrutierungsprozessen verwenden? Üben Sie jetzt und erhalten Sie Einblicke in Ihre Stärken und Schwächen.',
                gotoTestsPage: 'Gehe zum Bewertung Center',
                authIndication: {
                    title: 'Finde deinen Traumjob',
                    description:
                        'Möchten Sie Zugang zu Stellen, die einzigartig für Ihre Schule sind, und Tests, die Ihre Jobsuche beschleunigen? Erstellen Sie noch heute ganz einfach einen Benutzer mit Google, LinkedIn oder Facebook.',
                    action: 'Lass uns gehen',
                },
                toProfileHint: 'Zu meinem Profil',
                toProfileUncompletedHint:
                    'Ihr Profil ist nicht 100% vollständig. Bitte fahren Sie mit dem Ausfüllen fort, um Ihre Beschäftigungsfähigkeit zu maximieren.',
                profileActions: {
                    addFirstName: 'Vornamen hinzufügen',
                    addLastName: 'Nachnamen hinzufügen',
                    addNationality: 'Nationalität hinzufügen',
                    addPhoneNumber: 'Fügen Sie Ihre Telefonnummer hinzu',
                    addLanguage: 'Sprache hinzufügen',
                    addEducation: 'Eine Ausbildung hinzufügen',
                    addEmail: 'E-Mail hinzufügen',
                    addGender: 'Fügen Sie ihr Geschlecht hinzu',
                },
            },
            featuredCompanies: { label: 'Ausgewählte Unternehmen' },
            featuredPositions: { label: 'Ausgewählte Positionen' },
            featuredResource: {
                header: 'Nehmen Sie an der virtuellen Konferenz teil',
                cta: 'Schau jetzt!',
                wechatSignupHeader:
                    'Folgen Sie dem ,,Highered WeChat" Konto, um Updates zu erhalte',
                wechatSignupCta: '"Jetzt Code scannen!',
            },
        },
    },
    '"': 'Отсканируйте код сейчас!',
    cts: {
        filterNames: {
            employment_types: 'Beschäftigungsarten',
            education_level: 'Abschluss',
            job_category: 'Bereich',
            address: 'Standorte',
            sector: 'Sektoren',
            exclude_school_id: 'Ausschließen',
            languages: 'Sprachen',
        },
        excludeSchoolIds: {
            '-1': 'geteilte Beiträge',
            unknownSchoolId: 'EFMD-Schulpartner',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: 'BA',
            MASTERS_OR_EQUIVALENT: 'Diplom',
            DOCTORAL_OR_EQUIVALENT: 'PHD',
            MBA_OR_EQUIVALENT: 'MBA',
            DBA_OR_EQUIVALENT: 'DBA',
        },
        employmentTypes: {
            FULL_TIME: 'Ganztags',
            INTERN: 'Praktikum',
            TEMPORARY: 'Halbtags',
            PART_TIME: 'Halbtags',
        },
        startDate: 'Anfangen',
        educationFields: {
            ACCOUNTING_AND_FINANCE: 'Buchhaltung und Finanzen',
            ADMINISTRATIVE_AND_OFFICE: 'Verwaltung und Büro',
            ADVERTISING_AND_MARKETING: 'Werbung und Marketing',
            ART_FASHION_AND_DESIGN: 'Kunstmode und Design',
            BUSINESS_OPERATIONS: 'Geschäftsbetrieb',
            COMPUTER_AND_IT: 'Computer und IT',
            CUSTOMER_SERVICE: 'Kundendienst',
            EDUCATION: 'Bildung',
            HEALTHCARE: 'Gesundheitsfürsorge',
            HUMAN_RESOURCES: 'Personalabteilung',
            INSTALLATION_MAINTENANCE_AND_REPAIR: 'Installation Wartung und Reparatur',
            LEGAL: 'Rechtliches',
            MANAGEMENT: 'Management',
            MANUFACTURING_AND_WAREHOUSE: 'Fertigung und Lager',
            MEDIA_COMMUNICATIONS_AND_WRITING: 'Medienkommunikation und Schreiben',
            OIL_GAS_AND_MINING: 'Energie',
            PROTECTIVE_SERVICES: 'Schutzdienste',
            REAL_ESTATE: 'Grundeigentum',
            SALES_AND_RETAIL: 'Verkauf und Einzelhandel',
            SCIENCE_AND_ENGINEERING: 'Wissenschaft und Ingenieurswesen',
            SOCIAL_SERVICES_AND_NON_PROFIT: 'Soziale Dienste und gemeinnützige',
            TRANSPORTATION_AND_LOGISTICS: 'Transport und Logistik',
        },
        sectors: {
            Consulting: 'Beratung',
            'Consumer Goods': 'Gebrauchsgüter',
            'Financial Services / Banking': 'Finanzdienstleistungen / Bankwesen',
            'Goverment / Public Administration / Non Profit':
                'Regierung / Öffentliche Verwaltung / Gemeinnützig',
            'International Trade & Development': 'Internationaler Handel & Entwicklung',
            Manufacturing: 'Herstellung',
            'Media / Entertainment': 'Medien / Unterhaltung',
            'Petroleum / Energy': 'Erdöl / Energie',
            'Pharma / Healthcare / Biotech': 'Pharma / Gesundheitswesen / Biotechnologie',
            'Real Estate / Construction / Infrastructure': 'Immobilien / Bau / Infrastruktur',
            'Technology (IT) / Telecom': 'Technologie (IT) / Telekommunikation',
            'Transportations & Logistics': 'Transporte & Logistik',
            Other: 'Andere',
        },
        countries: {
            'China (Hong Kong SAR)': 'Hongkong',
            'Costa Rica': 'Costa Rica',
            'Europe & Sub-Saharan Africa': 'Europa & Subsahara-Afrika',
            'Hong Kong': 'Hongkong',
            'Korea, South': 'Südkorea',
            'New Zealand': 'Neuseeland',
            'Papua-Ny Guinea': 'Papua Neu-Guinea',
            'Puerto Rico': 'Puerto Rico',
            'Saudi Arabia': 'Saudi Arabien',
            'South Africa': 'Südafrika',
            'South Korea': 'Südkorea',
            'Sri Lanka': 'Sri Lanka',
            'Taiwan (Province of China)': 'Taiwan',
            'The Seychell Islands': 'Seychellen',
            'United Arab Emirates': 'Vereinigte Arabische Emirate',
            'United Kingdom': 'Vereinigtes Königreich',
            'Ivory Coast': 'Elfenbeinküste',
            Afghanistan: 'Afghanistan',
            Algeria: 'Algerien',
            Angola: 'Angola',
            Argentina: 'Argentinien',
            Armenia: 'Armenien',
            Australia: 'Australien',
            Austria: 'Österreich',
            Azerbaijan: 'Aserbaidschan',
            Bahamas: 'Bahamas',
            Bahrain: 'Bahrain',
            Bangladesh: 'Bangladesch',
            Belarus: 'Wit-Rusland',
            Belgium: 'Belgien',
            Botswana: 'Botswana',
            Brazil: 'Brasilianischë',
            Bulgaria: 'Bulgarien',
            Cambodia: 'Kambodscha',
            Canada: 'Kanada',
            Chile: 'Chili',
            China: 'China',
            Colombia: 'Kolumbien',
            Congo: 'Kongo',
            Croatia: 'Kroatien',
            Cyprus: 'Zypern',
            Czechia: 'Tschechien',
            Denmark: 'Dänemark',
            Ecuador: 'Ecuador',
            Egypt: 'Ägypten',
            Estonia: 'Estland',
            Ethiopia: 'Äthiopien',
            Fiji: 'Fidschi',
            Finland: 'Finnland',
            France: 'Frankreich',
            Germany: 'Deutschland',
            Ghana: 'Ghana',
            Greece: 'Griechenland',
            Guernsey: 'Guernsey',
            Hungary: 'Ungarn',
            Iceland: 'Island',
            India: 'Indien',
            Indonesia: 'Indonesien',
            Iraq: 'Irak',
            Ireland: 'Irland',
            Israel: 'Israel',
            Italy: 'Italien',
            Japan: 'Japan',
            Jersey: 'Jersey',
            Jordan: 'Jordanien',
            Kazakhstan: 'Kasachstan',
            Kenya: 'Kenia',
            Kuwait: 'Kuwait',
            Laos: 'Laos',
            Latvia: 'Lettland',
            Lebanon: 'Libanon',
            Lithuania: 'Litauen',
            Luxembourg: 'Luxemburg',
            Malaysia: 'Malaysia',
            Malta: 'Malta',
            Mauritania: 'Mauretanien',
            Mauritius: 'Mauritius',
            Mexico: 'Mexiko',
            Mongolia: 'Mongolei',
            Morocco: 'Marokko',
            Myanmar: 'Myanmar',
            Namibia: 'Namibia',
            Netherlands: 'Niederlande',
            Nigeria: 'Nigeria',
            Norway: 'Norwegen',
            Oman: 'Oman',
            Pakistan: 'Pakistan',
            Panama: 'Panama',
            Paraguay: 'Paraguay',
            Peru: 'Peru',
            Philippines: 'Philippinen',
            Poland: 'Polen',
            Portugal: 'Portugal',
            Qatar: 'Katar',
            Romania: 'Rumänien',
            Russia: 'Russland',
            Senegal: 'Senegal',
            Serbia: 'Serbien',
            Singapore: 'Singapur',
            Slovakia: 'Slowakei',
            Slovenia: 'Slowenien',
            Spain: 'Spanien',
            Sudan: 'Sudan',
            Swaziland: 'Swasiland',
            Sweden: 'Schweden',
            Switzerland: 'Schweiz',
            Syria: 'Syrien',
            Taiwan: 'Taiwan',
            Tanzania: 'Tansania',
            Thailand: 'Thailand',
            Tonga: 'Tonga',
            Turkey: 'Truthahn',
            Ukraina: 'Ukraine',
            Ukraine: 'Ukraine',
            USA: 'USA',
            Uzbekistan: 'Usbekistan',
            Vanuatu: 'Vanuatu',
            Vietnam: 'Vietnam',
            Zambia: 'Sambia',
        },
        languages: {
            Aceh: 'Aceh',
            Afrikaans: 'Afrikaans',
            Albanian: 'albanisch',
            Amharic: 'Amharisch',
            Arabic: 'Arabisch',
            Arakanese: 'Arakanesisch',
            Armenian: 'Armenisch',
            Azeri: 'Aserbaidschan',
            Badini: 'Badini',
            Basque: 'baskisch',
            Belarusian: 'Belarussisch',
            Bengali: 'Bengali',
            Berber: 'Berber',
            Bosnian: 'bosnisch',
            Bulgarian: 'bulgarisch',
            Burmese: 'birmanisch',
            Cantonese: 'Kantonesisch',
            Catalan: 'katalanisch',
            Cebuano: 'Cebuano',
            Chechen: 'Tschetschenien',
            Chin: 'Kinn',
            Chinese: 'Chinesisch',
            Croatian: 'kroatisch',
            Czech: 'Tschechisch',
            Danish: 'dänisch',
            Dari: 'Dari',
            Dutch: 'Niederländisch',
            English: 'Englisch',
            Estonian: 'estnisch',
            Faroese: 'Färöisch',
            Filipino: 'Philippinisch',
            Finnish: 'finnisch',
            French: 'Französisch',
            German: 'Deutsche',
            Greek: 'griechisch',
            Greenlandic: 'Grönländisch',
            Hausa: 'Hausa',
            Hebrew: 'hebräisch',
            Hindi: 'Hindi',
            Hungarian: 'ungarisch',
            Icelandic: 'isländisch',
            Indonesian: 'Indonesisch',
            Italian: 'Italienisch',
            Japanese: 'japanisch',
            Kazakh: 'Kasachisch',
            Kinyarwanda: 'Kinyarwanda',
            Kirundi: 'Kirundi',
            Korean: 'Koreanisch',
            Kurdish: 'kurdisch',
            Kurmanji: 'Kurmanji',
            Kven: 'Kven',
            Latin: 'Latein',
            Latvian: 'lettisch',
            Lingala: 'Lingala',
            Lithuanian: 'litauisch',
            Macedonian: 'mazedonisch',
            Malagasy: 'Madagassisch',
            Malaysian: 'malaysisch',
            Mandarin: 'Mandarin',
            Mongolian: 'mongolisch',
            Nepali: 'Nepalesisch',
            Norwegian: 'norwegisch',
            Oromo: 'Oromo',
            Other: 'Sonstiges',
            Panjabi: 'Panjabi',
            Pashto: 'Paschtu',
            Persian: 'persisch',
            Polish: 'Polnisch',
            Portuguese: 'Portugiesisch',
            Punjabi: 'Punjabi',
            Romanes: 'Romanes',
            Romani: 'Romani',
            Romanian: 'rumänisch',
            Russian: 'Russisch',
            Sami: 'Samisch',
            Serbian: 'serbisch',
            Sign_language: 'Zeichensprache',
            Slovak: 'slowakisch',
            Slovene: 'Slowenisch',
            Somali: 'somali',
            Sorani: 'Sorani',
            Spanish: 'Spanisch',
            Swahili: 'Swahili',
            Swedish: 'Schwedisch',
            Tagalog: 'Tagalog',
            Tamil: 'Tamil',
            Thai: 'Thai',
            Tigrinya: 'Tigrinya',
            Turkish: 'Türkisch',
            Ukrainian: 'ukrainisch',
            Urdu: 'Urdu',
            Uyghur: 'Uiguren',
            Vietnamese: 'Vietnamesisch',
            Wolof: 'Wolof',
        },
    },
    emailverification: {
        headerLabel: 'E-Mail-Verifizierung',
        verifyingEmail: 'E-Mail verifizieren',
        emailVerifySuccess: 'Deine Email wurde verifiziert!',
        emailVerifyFailure:
            'Ein Fehler ist aufgetreten. Versuchen Sie es später noch einmal oder wenden Sie sich an den Support',
        gotoMyPage: 'Zurück zu meiner Seite',
    },
    errors: {
        defaultErrorMessage: 'Ein Fehler ist aufgetreten!',
        logInErrorText: {
            invalidCredentials: 'Falscher Benutzername oder falsches Passwort',
            inactiveUser:
                'Der Benutzer mit der angegebenen E-Mail-Adresse ist inaktiv. Überprüfen Sie Ihre E-Mail auf Kontoaktivierung oder versuchen Sie, Ihr Passwort zurückzusetzen.',
            default: 'Es Konnte sich nicht authentifizieren.',
        },
        registerErrorText: {
            passwordTooShort: 'Das Passwort muss mindestens 8 Ziffern lang sein.',
            emailAlreadyInUse: 'Die angegebene E-Mail wird bereits verwendet.',
            emailTaken:
                'E-Mail wird bereits verwendet. Wenn Sie Ihre SchulE-Mail verwendet haben, kann dies passieren, weil Sie einen Benutzer hatten, bevor die Plattform aktualisiert wurde (bei highedtalent.org).',
            default: 'Konnte keinen Benutzer erstellen.',
        },
        invalidTokenText: { default: 'Ihr Token ist ungültig oder abgelaufen.' },
        passwordErrorText: {
            passwordTooShort: 'Das Passwort muss mindestens 8 Ziffern lang sein.',
            requireNonAlphanumeric: 'Das Passwort muss mindestens ein Sonderzeichen enthalten.',
            requireLowerCase: 'Das Passwort muss mindestens einen Kleinbuchstaben enthalten.',
            requireUpperCase: 'Das Passwort muss mindestens einen Großbuchstaben enthalten.',
            requireUniqueChars: 'Das Passwort muss mindestens 6 verschiedene Zeichen enthalten',
            default: 'Passwort konnte nicht geändert werden',
        },
        recoverErrorText: {
            userNotFound: 'Der Benutzer existiert nicht! Bitte wenden Sie sich an den Support.',
            userAlreadyActive:
                'Der Benutzer ist bereits aktiviert!\nBitte versuchen Sie sich anzumelden.',
            emailAlreadyInUse:
                'Die angegebene E-Mail-Adresse wird bereits verwendet.\nWenn Sie mit der Kontoaktivierung fortfahren möchten, versuchen Sie es mit einer anderen E-Mail-Adresse oder einem anderen sozialen Login. Fahren Sie andernfalls mit der Startseite fort und melden Sie sich bei Ihrem Konto an.',
            default: 'Konto konnte nicht aktiviert werden.\nBitte versuchen Sie es später erneut.',
        },
        socialAuthErrorText: {
            errorTitle: 'Anmeldung bei {provider} nicht möglich',
            invalidProviderGoogle:
                'Der Benutzer mit der angegebenen E-Mail ist nicht mit Google verbunden. Bitte versuchen Sie sich beispielsweise mit LinkedIn, Facebook oder E-Mail anzumelden.',
            invalidProviderFacebook:
                'Der Benutzer mit der angegebenen E-Mail ist nicht mit Facebook verbunden. Bitte versuchen Sie sich beispielsweise mit Google, LinkedIn oder E-Mail anzumelden.',
            invalidProviderLinkedIn:
                'Der Benutzer mit der angegebenen E-Mail ist nicht mit LinkedIn verbunden. Bitte versuchen Sie sich beispielsweise mit Google, Facebook oder E-Mail anzumelden.',
            invalidProviderWeChat:
                'Der Benutzer mit der angegebenen E-Mail ist nicht mit WeChat verbunden. Bitte versuchen Sie sich beispielsweise mit Google, Facebook oder E-Mail anzumelden.',
        },
        uniConnErrorText: {
            emailNotAvailable:
                'Die von Ihnen angegebene E-Mail-Adresse wird bereits verwendet. Dies könnte daran liegen, dass Sie einen Benutzer hatten, bevor die Plattform aktualisiert wurde (bei highedtalent.org). Bitte wenden Sie sich an den Support.',
            invalidEmailDomain:
                'Die angegebene E-Mail-Domain stimmt nicht mit der angegebenen Universität überein. Bitte wählen Sie die richtige Hochschule aus.',
            existingConnection:
                'Der Benutzer ist bereits mit der angegebenen Universität verbunden',
            default: 'Die Überprüfung konnte nicht eingeleitet werden.',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: 'E-Mail wird bereits verwendet',
                default: 'Konnte nicht aktualisieren',
            },
        },
    },
    favorites: {
        header: 'Meine Favoriten',
        active: 'Aktiv',
        expired: 'Abgelaufen',
        expiresThisMonth: 'Bewerbungsschluss diesen Monat',
        expiresThisWeek: 'Bewerbungsschluss diese Woche',
        expiresLater: 'Bewerbungsschluss später',
        noActiveFavorites: 'Sie haben keine aktiven Favoritenpositionen',
        noExpired: 'Sie haben keine abgelaufenen Favoritenpositionen',
    },
    findcompanies: {
        headerLabel: 'Unternehmen finden',
        companyListLabel: 'Firmen',
    },
    findjobs: {
        header: 'Arbeitsplätze finden',
        changeFilters: 'Filter ändern',
        recruitmentModule: {
            body: 'Sind Sie ein Arbeitgeber, ein Berufseinsteiger oder möchten Sie nur\n talentierte Studenten einstellen?',
            createJob: 'Klicken Sie hier, um eine Stellenanzeige zu erstellen',
        },
    },
    general: {
        documentTitle: 'Globale Chancenplattform',
        email: 'Email',
        password: 'Passwort',
        confirmPassword: 'Bestätigen Sie das Passwort',
        loading: 'Wird geladen',
        ok: 'OK',
        save: 'Speichern',
        add: 'Hinzufügen',
        close: 'Schließen',
        delete: 'Löschen',
        cancel: 'Stornieren',
        done: 'Erledigt',
        continue: 'Weitermachen',
        back: 'Zurück',
        next: 'Nächste',
        finish: 'Fertig',
        success: 'Erfolg',
        error: 'Fehler',
        description: 'Beschreibung',
        months: {
            0: 'Januar',
            1: 'Februar',
            2: 'März',
            3: 'April',
            4: 'Mai',
            5: 'Juni',
            6: 'Juli',
            7: 'August',
            8: 'September',
            9: 'Oktober',
            10: 'November',
            11: 'Dezember',
        },
        days: {
            0: 'Sonntag',
            1: 'Montag',
            2: 'Dienstag',
            3: 'Mittwoch',
            4: 'Donnerstag',
            5: 'Freitag',
            6: 'Samstag',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: 'Überprüfung Ihrer ausstehenden Bestätigung',
                verifySchoolConnection:
                    'Bestätigen Sie Ihre Schulverbindung, um auf diese Ressourcen zuzugreifen',
                logInToAccessMoreFeatures: 'Tausende internationale Karrieremöglichkeiten',
            },
        },
        minutesShort: 'Minute',
        poweredBy: 'Bereitgestellt von',
    },
    gptw: {
        company: {
            alt: 'GPTW',
            tooltip:
                'Dieses Unternehmen ist ein „guter Platz zum Arbeiten“-zertifiziertes Unternehmen',
        },
        posting: {
            label: {
                alt: 'GPTW',
                tooltip: "Dieser Beitrag gehört zu einem 'guter Platz zum Arbeit'-Unternehmen",
            },
            detail: {
                alt: 'GPTW',
                tooltip: {
                    isCertified: '{companyName} ist ein zertifizierter guter Platz zum Arbeiten',
                    readMore: 'Tippen Sie hier an, um mehr zu lesen',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: 'Bewerbungsschluss',
            location: 'Ort',
            employmentType: 'Beschäftigungsverhältnis',
            languageRequirements: 'Sprachanforderungen',
            workPermitRequirements: 'Anforderungen an die Arbeitserlaubnis',
            preferredEducationField: 'Bevorzugter Ausbildungsbereich',
            preferredEducationLevel: 'Bevorzugtes Bildungsniveau',
            jobTags: 'Stichworte',
            apply: 'Jetzt bewerben',
            verificationRequired:
                'Sie müssen Ihre Schul-E-Mail-Adresse bestätigen, um sich zu bewerben.',
            verificationRequiredHint:
                'Sie müssen Ihre Schul-E-Mail-Adresse bestätigen, um sich zu bewerben',
            verificationPending: 'Sie haben eine ausstehende Überprüfung an dieser Schule',
            verificationPendingHint: 'Sie haben eine ausstehende Überprüfung an dieser Schule',
        },
        invalidJobAd: {
            caption:
                'Entschuldigung, aber wir konnten diese Stelle nicht finden. Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte über die Chatbox unten an den Support.',
            btn: 'Andere Jobs finden',
        },
    },
    mypage: {
        header: 'Meine Seite',
        suggestedPositions: 'Vorgeschlagene Positionen',
        favoriteModule: {
            header: 'Meine Lieblingspositionen',
            seeAll: 'Alles sehen',
            noFavorites: 'Sie haben keine aktiven Favoritenpositionen',
        },
    },
    recoverpassword: {
        createPassword: 'Erstellen Sie ein neues Passwort',
        newPasswordLabel: 'Neues Passwort',
        newPasswordPlaceholder: 'Passwort',
        confirmPasswordLabel: 'Bestätigen Sie das Passwort',
        confirmPasswordPlaceholder: 'Bestätigen Sie das Passwort',
        resetPasswordButton: 'Passwort zurücksetzen',
        resettingPassword: 'Passwort zurücksetzen',
        passwordsNotMatching: 'Passwörter stimmen nicht überein.',
    },
    recoveruser: {
        headerLabel: 'Höherer Benutzer wiederherstellen',
        accountActivation: 'Account Aktivierung',
        step1: {
            header: 'Willkommen auf unserer neuen Plattform!',
            subHeader: 'Wählen Sie aus, wie Sie sich mit Ihrem Konto verbinden möchten',
            description:
                'Für einen einfacheren Login-Prozess empfehlen wir Ihnen, Ihr Konto mit mindestens einem der folgenden Dienste zu verbinden',
            OR: 'oder',
            emailAndPassword: 'Verwenden Sie Ihre eigene E-Mail',
        },
        step2: {
            header: 'E-Mail und Passwort verwenden',
            description:
                'Dies ist die Haupt-E-Mail, die Ihrem Konto zugeordnet wird. Wir empfehlen Ihnen, eine andere E-Mail-Adresse als Ihre Universitätsadresse zu verwenden, um auch nach dem Studium Zugriff auf Ihre Daten zu haben. Sie können ganz einfach in Ihren Kontoeinstellungen steuern, welche E-Mails Sie von uns erhalten.',
            invalidEmail: 'Die angegebene E-Mail ist ungültig.',
            passwordsNotMatch: 'Die Passwörter müssen übereinstimmen',
            passwordDescription01:
                'Um die Sicherheit Ihres Kontos zu gewährleisten, müssen Sie ein neues Passwort festlegen. Bitte erstellen Sie ein Passwort mit folgendem:',
            passwordDescription02: 'Mindestens 8 Zeichen',
            passwordDescription03: 'Mindestens ein Kleinbuchstabe (a-z)',
            passwordDescription04: 'Mindestens ein Großbuchstabe (A-Z)',
            passwordDescription05: 'Mindestens eine Zahl oder ein Sonderzeichen (0-9, !#$ usw.)',
            passwordDescription06: 'Mindestens 6 einzigartige Charaktere',
            repeatPassword: 'Passwort wiederholen',
        },
        step3: {
            header: 'Benutzer aktivieren',
            loadingHints: {
                0: 'Benutzerdaten laden',
                1: 'Alles fertig machen',
                2: 'Neue Möglichkeiten um die Ecke',
                3: 'Fast fertig!',
            },
            successHeader: 'Ihr Konto ist jetzt einsatzbereit!',
            successSubheader: 'Sie können jetzt auf neue exklusive Funktionen zugreifen!',
            errorHeader: 'Konto konnte nicht aktiviert werden',
            ifWrongContact:
                'Wenn Sie der Meinung sind, dass dies falsch ist, wenden Sie sich bitte an den Support',
            contactForHelp: 'Kontakt für Hilfe',
            goBack: 'Geh zurück',
        },
    },
    resourcesInternal: {
        header: 'Ressourcen',
        resourceTypeHeader: 'Typ',
        resourceNoContent: 'Ihre Schule hat die Ressourcenfunktion noch nicht aktiviert.',
        resourceFolderNoContent: 'In diesem Ordner sind keine Ressourcen verfügbar',
        resourceTitleHeader: 'Titel',
        resourcePublishDateHeader: 'Veröffentlicht',
        searchPlaceholder: 'Nach Name oder Stichwort suchen ...',
        cvTemplateHeader: 'HÖHERE CV-VORLAGE (ATS-FREUNDLICH)',
        cvTemplateSubtitle: 'Hier herunterladen!',
    },
    shared: {
        userNavSection: {
            myPage: 'Meine Seite',
            myProfile: 'Mein Profil',
            myTests: 'Einschätzungen',
            myApplications: 'Anwendungen',
            myFavorites: 'Favoriten',
            resources: 'Ressourcen',
            calendar: 'Kalender',
            documents: 'Lebenslauf hochladen',
        },
        searchModule: {
            searchBar: { label: 'Suche nach Titel oder Stichworten' },
            filters: { clearFilters: 'Filter löschen' },
            filterLimit: {
                title: 'Filtergrenze erreicht',
                message: 'Es können keine weiteren Filter dieses Typs ausgewählt werden',
            },
        },
        postingModule: {
            postingModule: {
                positions: 'Positionen',
                estimatedCount: 'ca. {count} von {totalCount}',
                knownCount: '{count} von {totalCount}',
                noMatchFound: 'Es wurde nichts gefunden, das Ihren Kriterien entspricht',
            },
            postItem: { applyBefore: 'Bewerbungsschluss' },
            postCard: { deadline: 'Termin' },
        },
        loginModule: {
            emailVerificationTip:
                'Es kann einige Minuten dauern, bis es Ihren Posteingang erreicht.',
            noEmail: 'Keine Email? Bitte überprüfen Sie Ihren Spam-Filter oder:',
            logIn: 'Einloggen',
            socialAuthBtns: {
                continueWithFacebook: 'Weiter mit Facebook',
                continueWithGoogle: 'Weiter mit Google',
                continueWithLinkedIn: 'Weiter mit LinkedIn',
                continueWithWeChat: 'Weiter mit WeChat',
            },
            verifyEmail: {
                verifyYourEmail: 'Bitte bestätige deine E-Mail',
                weSentAnEmailTo: 'Wir haben eine Bestätigung gesendet an',
                continueToSignIn: 'Weiter zur Anmeldung',
                resendEmail: 'Bestätigungslink erneut senden',
                newEmailSent: 'Neue E-Mail gesendet',
            },
            registerForm: {
                recommendation:
                    'Wir empfehlen Ihnen, Ihre persönliche E-Mail-Adresse und nicht die E-Mail-Adresse Ihrer Schule zu verwenden, um sicherzustellen, dass Sie nach Ihrem Abschluss Zugriff auf Ihre Daten haben.',
                register: 'Registrieren',
                passwordsNotMatch: 'Die Passwörter stimmen nicht überein',
            },
            logInPaper: {
                useEmail: 'oder benutzen Sie Ihre E-Mail',
                noAccount: 'Haben Sie kein Konto?',
                signUp: 'Anmelden',
                logInToAccess: 'Melden Sie sich an, um auf diese Funktion zuzugreifen',
                showAllOptions: 'Alle Login-Optionen anzeigen',
                hideAllOptions: 'Zeige weniger',
            },
            logInForm: { logIn: 'Einloggen', forgotPassword: 'Passwort vergessen?' },
            forgotPassword: {
                title: 'Fordere Passwort-Reset an',
                description:
                    'Keine Sorge – jeder vergisst von Zeit zu Zeit sein Passwort.\nGeben Sie unten Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen',
                resetPassword: 'Passwort zurücksetzen',
                emailSentTitle: 'Ihre Hilfe ist unterwegs!',
                emailHasBeenSent:
                    'Es wurde eine E-Mail an\n <br>\n <strong>{email}</strong>\n <br>\n mit Anweisungen zum Zurücksetzen Ihres Passworts gesendet. Bitte überprüfen Sie Ihren\n Posteingang.',
                noEmail: 'Keine Email?',
                sendEmailOneMoreTime: 'E-Mail noch einmal senden',
                resendErrorTitle: 'Fehler beim Wiederherstellen des Passworts',
                resendErrorMessage:
                    'Die E-Mail zur Passwortwiederherstellung konnte nicht gesendet werden. Vielleicht falsche E-Mail?',
            },
        },
        termsAndConds: {
            termsAndConditions: 'Geschäftsbedingungen',
            privacyPolicy: 'Datenschutz-Bestimmungen',
            talentPanel: 'Schule/Arbeitgeber?',
        },
        favoriteModule: {
            favoriteCard: {
                deleted: 'Gelöscht',
                deletedTitle: 'Diese Stelle ist nicht mehr verfügbar',
            },
        },
        pageNotFound: {
            description: 'Die gesuchte Seite nicht mehr hier.',
            goToHome: 'Zur Startseite gehen',
            contactus: 'Kontaktiere uns',
        },
        chat: {
            liveNow: 'Jetzt live im Chat!',
            seeAll: 'Alle',
            schoolSpecificChats: 'Schneller Zugang',
            help: 'Brauchen Sie Hilfe?',
            chatExistsLabel: 'Chat existiert',
        },
        countdown: {
            day: 'Tag',
            days: 'Tage',
            hour: 'Stunde',
            hours: 'Stunden',
            minute: 'Minute',
            minutes: 'Minuten',
            second: 'Sekunde',
            seconds: 'Sekunden',
        },
    },
    spotlight: {
        header: 'Mein Profil',
        saveChangesToSubmit: 'Speichern Sie Ihr Profil, damit die Änderungen wirksam werden',
        saveChanges: 'Änderungen speichern',
        saveSuccessful: 'Ihre Änderungen wurden erfolgreich gespeichert',
        personalDetails: {
            header: 'Persönliche Daten',
            firstName: 'Vorname',
            lastName: 'Familienname, Nachname',
            nationality: 'Nationalität',
            gender: 'Geschlecht',
            uploadProfileImage: 'Foto hochladen',
            genderOptions: {
                male: 'Männlich',
                female: 'Weiblich',
                other: 'Sonstiges',
                none: 'Mache lieber keine Angabe',
                unknown: 'Unbekannt',
            },
            wrongFileTypeErrorHeader: 'ungültiger Dateityp',
            wrongFileTypeErrorDescription: 'Sie können nur Bilder hochladen',
        },
        summary: { header: 'Zusammenfassung' },
        contactDetails: {
            header: 'Kontaktdetails',
            contactEmail: 'Kontakt E-mail',
            phoneNumberHeader: 'Handynummer',
            countryCode: 'Landesvorwahl',
            phoneNumber: 'Telefonnummer',
            invalidEmail: 'Die eingegebene E-Mail ist keine gültige E-Mail.',
            permanentEmail:
                'HINWEIS: Diese Änderung ist dauerhaft. Sie können Ihre E-Mail-Adresse nur einmal festlegen.',
        },
        languages: {
            header: 'Sprachen',
            languageLabel: 'Sprache',
            levelLabel: 'Niveau',
            addLanguage: 'Neue Sprache hinzufügen',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': 'Grundkenntnisse',
                '82edcac6-693b-42ea-bf24-0a52774f395c': 'Eingeschränkte Arbeitsfähigkeit',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63': 'Professionelle Arbeitsleistung',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': 'Volle Fachkompetenz',
                '250d296e-d6db-46fb-8c44-07950db80ec4': 'Muttersprache oder Zweisprachig',
            },
        },
        education: {
            header: 'Bildung',
            addEducation: 'Bildung hinzufügen',
            notGraduated: 'Noch nicht absolviert',
            graduatedIn: 'Absolviert am {date}',
            dialog: {
                addNewEducation: 'Neue Ausbildung hinzufügen',
                degreeTitle: 'Programm',
                institution: 'Institution',
                degreeType: 'Abschluss',
                fieldOfStudy: 'Arbeitsbereich',
                cannotFindField: 'Ich kann nicht meine Arbeitsfeld finden',
                studyStart: 'Startmonat',
                studyEnd: 'Abschlussmonat',
                invalidDegreeTitle: 'Sie müssen einen Titel Ihres Programms eingeben.',
                invalidSchool: 'Sie müssen eine Schule auswählen.',
                invalidStartDate: 'Bitte wählen Sie ein Startdatum',
                invalidEndDate: 'Bitte wählen Sie ein Abschlussdatum',
                invalidStudyPeriod: 'Sie können nicht vor dem Startdatum Ihren Abschluss machen.',
                invalidDegreeField: 'Bitte geben Sie eine gültige Studienrichtung ein.',
                invalidDegreeLevel: 'Bitte wählen Sie eine gültige Stufe Ihres Abschlusses aus.',
                selectStartDate: 'Anfangsdatum',
                selectEndDate: 'Abschlussdatum',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': 'Bakkalaureus',
                    '09f419fa-1517-41ce-970c-df0d073fc440': 'Diplom',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                    '2fbd6155-d939-40cc-970d-283be0aef433': 'Doktorat',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': 'Landwirtschaft und Forstwirtschaft',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': 'Angewandte Wissenschaften & Berufe',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': 'Kunst, Design & Architektur',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': 'Geschäft & Management',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': 'Informatik & IT',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': 'Wirtschaft',
                    '5c0432d4-9297-429a-85c4-3305d207764e': 'Bildung & Ausbildung',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': 'Ingenieurwissenschaften',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd': 'Umweltstudien und Geowissenschaften',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': 'Gastronomie, Freizeit & Sport',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': 'Geisteswissenschaften',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': 'Journalismus & Medien',
                    'a2744908-9521-4330-a07d-3680b058d0a6': 'Jura',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': 'Marketing',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60': 'Diplom in Innovation und Wirtschaft',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': 'Diplom in Entwicklungsmanagement',
                    'a37667e2-5713-4157-82e9-78c10760d2de': 'Diplom in Datenwissenschaft',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': 'Medizin & Gesundheit',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': 'MS in Finanzen',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4': 'MS in International Business Studies',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': 'MS in Business Analytics',
                    '7d832109-642a-4730-aada-26927eb683ee': 'MS in Management',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': 'Naturwissenschaften & Mathematik',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': 'Sozialwissenschaften',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': 'Sonstiges',
                },
            },
        },
        workAuthorization: {
            header: 'Arbeitserlaubnis',
            addWorkAuthorization: 'Arbeitsberechtigung hinzufügen',
            implicitValue: 'Auf Ihrer Nationalität basiert',
            dialog: {
                selectCountry: 'Land auswählen',
                addEuWorkAuthorization: 'EU-Arbeitserlaubnis hinzufügen',
            },
        },
        communication: {
            header: 'Kommunikation',
            sendMeUpdatesDescription:
                'Bitte senden Sie mir Karriere-News, Positionen und Unternehmens-Updates per E-Mail',
        },
        errors: {
            imageUpload: {
                title: 'Bild konnte nicht hochgeladen werden.',
                message: 'Bild ist zu groß!',
            },
        },
        exitDialog: {
            title: 'Nicht gespeicherte Änderungen gehen verloren',
            message:
                'Sie versuchen, die Seite zu verlassen, ohne Ihre Änderungen zu speichern. Möchten Sie Ihr Profil speichern, bevor Sie fortfahren?',
            stayAction: 'Bleiben Sie auf dieser Seite',
            saveAction: 'Profil sichern',
            continueAction: 'Ohne Speichern fortfahren',
        },
    },
    tests: {
        header: 'Tests',
        unauthorized:
            'Die Tests befinden sich derzeit in der geschlossenen Beta. Sie haben noch keinen Zugriff auf diese Funktionen. Sie werden bald verfügbar sein!',
        error: 'Beim Versuch, die Tests zu laden, ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
        assessmentModule: { header: 'Ihre Einschätzung' },
        completedYourProfile:
            'Sie müssen Ihr Profil vervollständigen, um Zugang zu dieser Bewertung zu erhalten',
        toMyProfile: 'Mein Profil bearbeiten',
    },
    vfair: {
        header: 'Virtuelle EFMD-Veranstaltungen',
        activeNow: 'Laufend',
        visibilityPrivate: 'Privat',
        visibilityNetwork: 'Netzwerk',
        visibilityOpen: 'Offen',
        interested: 'Registrieren',
        attend: 'Nehmen Sie an der Veranstaltung teil',
        enterEvent: 'Betreten Sie die virtuelle Veranstaltung',
        notinterested: 'Ich habe kein Interesse mehr',
        shownInterest: 'Eingetragen',
        signUpToday: 'Heute anmelden!',
        vfairsInfo:
            'Verbinden Sie sich mit Unternehmen und Organisationen aus der ganzen Welt in einer hochentwickelten Simulationsumgebung für Jobmessen, die eine Echtzeit-Interaktion zwischen Personalvermittlern und Kandidaten ermöglicht. Klicken Sie auf die virtuelle Veranstaltung, an der Sie interessiert sind, und melden Sie sich an, um Benachrichtigungen zu erhalten.',
        recruitingOrgs: 'Rekrutierung von Unternehmen und Organisationen',
        preRegistered: 'Vorregistriert',
        prepareForTheFair: 'Bereiten Sie sich auf das virtuelle Event vor',
        privateVFairHeader: 'Virtuelle Campus-Veranstaltung',
        privateVFairMessage:
            'Diese virtuelle Veranstaltung wird auf einer EFMD-Schulplattform gehostet und kann daher von hier nicht aufgerufen werden.',
        schoolNotJoinedNetworkEventMessage:
            'Ihre Schule hat sich noch nicht für diese virtuelle Veranstaltung angemeldet. Wenden Sie sich an Ihren Programmdirektor oder Ihre Karriereabteilung, um eine Teilnahme zu beantragen.',
        companyNotJoinedNetworkEventMessage:
            "Ihre Organisation hat bei dieser Veranstaltung keinen aktiven virtuellen Stand. Wenden Sie sich an ̦̦Highered'' um Teilnahme zu bitten.",
        pavilions: 'Pavillons',
        general: 'Allgemein',
        allCompanies: 'Alle Unternehmen',
        lobby: 'Eingangshalle',
        inviteCode: 'Einladungscode',
        eventRequiresInvitation: 'Für diese Veranstaltung ist eine Einladung erforderlich',
        haveCode: 'Ich habe einen Code',
        checkCode: 'Code überprüfen',
        invalidCode: 'Ungültiger Code',
        registeredSuccessfully: 'Erfolgreich registriert',
        pavilionTabs: {
            home: 'Heim',
            companies: 'Firmen',
            articles: 'Artikel',
            jobs: 'Arbeitsplätze',
            events: 'Veranstaltungen',
        },
        events: {
            noEventsAvailable: 'Keine Veranstaltungen verfügbar',
            showCompleted: 'Show fertiggestellt',
            hideCompleted: 'Fertiggestellten ausblenden',
            liveNow: 'Live jetzt',
            joinTheEvent: 'Bei der Veranstaltung teilnehmen',
            addToCalendar: 'Zum Kalender hinzufügen',
        },
        links: {
            masterclasses: {
                header: 'Meister Klasse',
                buttonCaption: 'Sehen Sie sich die Meisterkurse an',
                description:
                    'Sehen Sie sich eine große Auswahl an erstklassigen Meisterkursen an, darunter „Lebenslaufoptimierung, um eingestellt zu werden“, „Rock dein Linkedin Profil“ und „Gehaltsverhandlung“ für alle Phasen Ihrer Karriere!',
            },
            detailsmasterclass: { header: 'Besuchen Sie den Meisterkurs' },
            cv: {
                header: 'Lebenslauf-Vorlage',
                buttonCaption: 'Lebenslaufvorlage herunterladen',
                description:
                    'Greifen Sie auf die höhere ATS-freundliche Lebenslaufvorlage zu, um bei Personalvermittlern einen optimalen professionellen Eindruck zu hinterlassen.',
            },
            elevatorPitch: {
                header: 'Aufzugspräsentation Herausforderung',
                buttonCaption: 'Senden Sie Ihren Punkt',
                description:
                    'Nehmen Sie an der „Punkt genau Herausforerung“ teil! Dies ist Ihre Gelegenheit, Ihren Wert Hunderten von Personalvermittlern von führenden globalen Unternehmen und Organisationen zu präsentieren!',
            },
        },
        footerHeaders: {
            social: 'Folgen Sie uns für weitere Updates',
            sponsored: 'Gesponsert von',
            organized: 'Organisiert von',
        },
        educationPopup: {
            step00: {
                header: 'Teilen Ihre Ausbildung',
                subtitle: 'Um fortzufahren, lassen Sie die Arbeitgeber mehr über Sie wissen',
                continueLabel: 'Meine Ausbildung hinzufügen',
                leaveLabel: 'Zurückweisen',
            },
            step01: { header: 'Erzähl uns deine Ausbildung' },
            step02: { loadingLabel: 'Einen Augenblick...' },
            step03: {
                header: 'Ausbildung abgeschlossen',
                subtitle:
                    'Sie können jetzt Ihr Profil teilen und unter den Arbeitgebern interessanter werden',
                continueLabel: 'Erkunden Sie das virtuelle Event weiter',
            },
            error: {
                header: 'Wups! Ein Fehler ist aufgetreten!',
                subtitle:
                    'Wir konnten Ihre Bildungsinformationen nicht speichern. Bitte versuchen Sie es später erneut.',
            },
        },
    },
};
